import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
} from "@angular/core";
import {AuthService} from "../../services/auth.service";
import {CustomError} from "src/app/modules/shared/interfaces/CustomError.interface";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import {Subscription} from "rxjs";
import {TranslateService, TranslateModule} from "@ngx-translate/core";
import {RouterLink} from "@angular/router";

@Component({
  selector: "app-forgotten-password-form",
  templateUrl: "./forgotten-password-form.component.html",
  styleUrls: ["./forgotten-password-form.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule, TranslateModule, RouterLink],
})
export class ForgottenPasswordFormComponent implements OnDestroy {
  sendTokenForm: FormGroup;
  tokenSent = false;
  error!: CustomError;
  private readonly userLanguage = navigator.language.startsWith("fr")
    ? "fr"
    : "en";
  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly translate: TranslateService,
    private readonly formBuilder: FormBuilder,
    private readonly authService: AuthService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.sendTokenForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });

    this.translate.defaultLang = this.userLanguage;
    this.translate.reloadLang(this.userLanguage);
    this.translate.use(this.userLanguage);
  }

  onSubmit() {
    if (this.sendTokenForm.invalid) {
      this.error = {
        error: {
          error: "Please fill all required fields",
        },
      };
      return;
    }

    const sendResetTokenSubscription = this.authService
      .sendResetToken(this.sendTokenForm.value.email)
      .subscribe({
        next: () => {
          this.tokenSent = true;
          this.cdr.markForCheck();
        },
        error: (error: CustomError) => {
          this.error = error;
          this.cdr.markForCheck();
        },
      });
    this.subscriptions.push(sendResetTokenSubscription);
  }

  ngOnDestroy() {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }
}
